export type SeatVisualState = "available" | "selected" | "unavailable" | "ExitRow";

export function getSeatVisualState(isAvailable: boolean, isSelected: boolean, isExit:boolean): SeatVisualState {
  if (!isAvailable) return "unavailable";
  if (isSelected) return "selected";
  if (isExit) return "ExitRow";
  return "available";
}

export const SEAT_FILL_CLASSNAME: Record<SeatVisualState, string> = {
  available: "fill-background-subtle!",
  selected: "fill-background-primary!",
  unavailable: "fill-background-disabled! stroke-border-disabled!",
  ExitRow: `fill-font-danger!`,
};
